import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';

import {
  TXTCLI_OK,
  TXTWCL_Click_XaXhereX_aX_for_general__ELL,
  TXTWCL_Sorry___an_error_has_occurred
} from './CasinoRacePromoBan.messages.json';
import styles from './CasinoRacePromoBan.scss';

interface CasinoRacePromoBan {
  title?: TranslationTag;
  message: string | TranslationTag;
}

const CasinoRacePromoBan: React.FC = () => {
  const { title, message } = useSearchParams<CasinoRacePromoBan>();

  const {
    modal: { close }
  } = useDispatch<Dispatch>();

  return (
    <>
      <Header>
        <Translation {...(title || TXTWCL_Sorry___an_error_has_occurred)} />
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <p>{message as string}</p>
        <Translation
          tagName="p"
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.PRMCasinoPromoTerms}>{msg}</ResolverLink>
            )
          }}
          {...TXTWCL_Click_XaXhereX_aX_for_general__ELL}
        />
        <StarsButton onClick={() => close()} translation={TXTCLI_OK} className={styles.button} />
      </Body>
    </>
  );
};

export default CasinoRacePromoBan;
